"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppStoresBanner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_next_1 = require("@geome/react-next");
const useIconFor_1 = require("@geome/react-components-next/lib/components/properties/hooks/useIconFor");
const shell_locator_icons_1 = __importDefault(require("@geome/shell-locator-icons"));
const react_1 = require("react");
const AppStoresBanner = () => {
    var _a, _b;
    const { translate } = (0, react_next_1.useI18n)();
    const appBannerConfig = (0, react_next_1.useConfig)("app_stores_banner");
    if (!appBannerConfig || (appBannerConfig.ios_link === "" && appBannerConfig.google_link === ""))
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "app-stores-banner", children: [(0, jsx_runtime_1.jsx)("div", { className: "app-stores-banner__title", children: translate("app_stores_banner.title") }), (0, jsx_runtime_1.jsxs)("div", { className: "app-stores-banner__buttons", children: [((_a = appBannerConfig.ios_link) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((0, jsx_runtime_1.jsx)("a", { href: appBannerConfig.ios_link, className: "app-stores-banner__link app-stores-banner__link--ios", children: (0, jsx_runtime_1.jsx)(AppStoreIcon, {}) })), ((_b = appBannerConfig.google_link) === null || _b === void 0 ? void 0 : _b.length) > 0 && ((0, jsx_runtime_1.jsx)("a", { href: appBannerConfig.google_link, className: "app-stores-banner__link app-stores-banner__link--google", children: (0, jsx_runtime_1.jsx)(GooglePlayIcon, {}) }))] })] }));
};
exports.AppStoresBanner = AppStoresBanner;
const AppStoreIcon = () => {
    const locale = (0, react_next_1.useConfig)("locale");
    const countryCode = (0, react_1.useMemo)(() => locale === null || locale === void 0 ? void 0 : locale.split("_").at(1), [locale]);
    const { translate } = (0, react_next_1.useI18n)();
    const iconSrc = (0, useIconFor_1.useIconFor)("app_stores.banner_ios", countryCode, shell_locator_icons_1.default);
    return ((0, jsx_runtime_1.jsx)("img", { src: iconSrc, height: 40, alt: translate("app_stores_banner.ios_button_alt") }));
};
const GooglePlayIcon = () => {
    const locale = (0, react_next_1.useConfig)("locale");
    const countryCode = (0, react_1.useMemo)(() => locale === null || locale === void 0 ? void 0 : locale.split("_").at(1), [locale]);
    const { translate } = (0, react_next_1.useI18n)();
    const iconSrc = (0, useIconFor_1.useIconFor)("app_stores.banner_google", countryCode, shell_locator_icons_1.default);
    return ((0, jsx_runtime_1.jsx)("img", { src: iconSrc, height: 40, alt: translate("app_stores_banner.google_button_alt") }));
};
